module.exports = __webpack_public_path__ + "img/logo.f7c39ad9.svg";